import { useCallback, useEffect, useState } from 'react';
export function useResource(cache, key, load, enabled = true) {
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ loading: true, data: null, error: null, key, load, enabled });
  useEffect(() => {
    if (!enabled) {
      setState((previous) => ({ ...previous, enabled: false }));
      return;
    }
    let active = true;
    setState({ loading: true, data: null, error: null, key, load, enabled });
    const resource = cache.acquire(key, load);
    resource.promise.then((data) => {
      if (active) setState({ loading: false, data, error: null, key, load, enabled });
    }, (error) => {
      if (active) setState({ loading: false, data: null, error, key, load, enabled });
    });
    return () => { active = false; resource.release(); };
  }, [cache, key, load, attempt, enabled]);
  const retry = useCallback(() => setAttempt((n) => n + 1), []);
  if (enabled && (!state.enabled || state.key !== key || state.load !== load)) {
    return { loading: true, data: null, error: null, retry };
  }
  return { loading: state.loading, data: state.data, error: state.error, retry };
}
